<template>
  <div class="container-fluid">

  <div v-if="type=='B'">
    <priceUpForm  @update="setFinish"  v-bind:update="update" v-bind:items="sizesPricing" v-bind:doc="doc" v-bind:variants="variants" v-bind:counter="counter"  v-bind:sizes="sizes" v-bind:product="localProduct" @back="type='A'"></priceUpForm>   
   
  </div>


  <div v-else>

   <div  class="page-header_">

    <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />
 
    
    <div class="row">
      

      <productCollections ref="productCollections" v-bind:productId="localProduct.productId"></productCollections>      
      
      <!-- SIZES LIST-->  
      <sizes-list ref="sizesTable" v-if="refresh" v-bind:selection="sizes" @update="setSizes"></sizes-list>

     

    </div>

    </div>
    
  


  <div class="card border-0">

  <div class="btn-group" role="group" aria-label="Basic example">

     <button @click="$emit('back')"  class="btn btn-secondary">
     <i style="color:yellow" class="fas fa-reply  mr-2" aria-hidden="true"></i>
        RITORNA AL DOCUMENTO PRODOTTI
    </button>

    <button @click="productCollections()"  class="btn btn1">
     <i style="color:black" class="fas fa-list  mr-2" aria-hidden="true"></i>
      <strong> COLLEZIONI DEL PRODOTTO</strong>
    </button>

    <button @click="sizesTable()"  class="btn btn2">
     <i style="color:black" class="fas fa-ruler-combined  mr-2" aria-hidden="true"></i>
       <strong> TABELLA MISURE</strong>
    </button>

    <button @click="newColor()"  class="btn btn3">
     <i style="color:black" class="	fas fa-paint-brush  mr-2" aria-hidden="true"></i>
       <strong> NUOVO COLORE</strong>
    </button>
  
  </div>
  <modalNewColor class="mt-1" ref="newColor" ></modalNewColor>
  </div>


    
    <form   v-on:submit.prevent="submit()">
     <div class="table-responsive-sm">       
      <table class="table table-bordered table-hover table-sm mb-0 mt-1 my-table">
         <caption>Inserimento varianti colore/misura
          
         <span v-if="false" class="badge badge-pill badge-dark ml-3">
            Totale Acquistato   : {{ totaliGenerali.ordinato }}
         </span>
        </caption>
        <thead class="thead-light">
           <tr >

            <th class="text-center" :colspan="sizes.length+4" style="background-color:  #5c8fb1; font-weight:bold;" >
               <document-header class="text-center"  v-bind:doc="doc" v-bind:textColor="'white'"></document-header> 
            
            </th>            
            

            
           </tr> 
           <tr class="header-measures">
            
            <th class="text-center" :colspan="sizes.length+4" style="background_:#f8f9fa; font-weight:bold;" >
               
               <h5 v-if="!update">REGISTRAZIONE NUOVO MOVIMENTO ACQUISTO VARIANTI</h5>
              <h5 v-else>MODIFICA MOVIMENTO ACQUISTO VARIANTI </h5>

              
              <product-info v-bind:productId="localProduct.productId"></product-info>   
              <productSizeList v-if="!update"  v-bind:props = "localProduct" @update="setProductSizesList"></productSizeList>
            </th>            
            
          </tr>  


          <tr class="header-measures">
            <th></th> <th></th> <th></th>                                  
            <th class="text-center" :colspan="sizes.length" style="background_:#f8f9fa; font-weight:bold;" > MISURE </th>            
            <th :style="{ width:  'auto' }" class="text-right"></th>
          </tr>
          
          <tr>
                <th  :style="{ width:  'auto' }">RIGA</th>
                <th  :style="{ width:  'auto' }" class="sticky-col_ sticky-color_">COLORE</th>
                <th  :style="{ width:  'auto' }"class="sticky-col_ sticky-desc_">COLORE FORNITORE</th>

            <th v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center sticky-col" :style="{ width:  'auto_' }">
              {{ size.size }}
              <button v-if="false" class="btn btn-sm btn-danger ml-1" @click="removeSize(sIndex)"></button>
            </th>

            <th :style="{ width:  'auto' }" class="text-right">TOTALE</th>
          </tr>
        </thead>

        <tbody>

          <tr v-for="(variant, vIndex) in variants" :key="vIndex" :class="{ 'row-zero': isRowAllZero(variant) }">          

            

            <td class="sticky-col sticky-color">
                  <div class="d-flex align-items-center">

                      <!-- Numero riga -->
                    <span class="ml-2 mr-2">{{ vIndex + 1 }}</span>

                    <!-- Bottone -->
                    <button
                    
                      

                      title="Elimina riga"
                      class="btn btn-light btn-sm d-flex align-items-center"
                      type="button"
                      @click="removeVariant(vIndex)"
                    >
                      
                       <i  class="fas fa-trash-alt "></i>
                    </button>

                    

                  </div>
          </td>

          <td  class="sticky-col sticky-color">
            
            <div class="input-group input-group-sm align-items-stretch">
            
              
              <!-- vSELECT COLOR  -->
              <v-select-colors

              ref="vColor"
              :disabled="variant.vSelectDisabled"
              :required="true"  
              :key="variant.colorId + '-color'"   
              v-bind:Id="variant.colorId"
             
              v-bind:vIndex="vIndex" 
              v-bind:variants="variants" 
              class="flex-grow-1" 
              @update="setColor"
              @setColors="setColors"
              :colors="colors"
              >
              
              </v-select-colors>              

            </div>
          </td>
            
          <td  class="sticky-col sticky-desc">
              <div class="input-group input-group-sm align-items-stretch">

                  <input
                      :ref = "'supplierColor-' +  vIndex" 
                      
                      type="text"
                      class="form-control form-control-sm"
                      v-model="variant.supplierColor"
                      placeholder="Inserisci colore fornitore"
                    />
                <div class="input-group-prepend">
                        <button v-if="vIndex==0"
                        type       = 'button'
                        title      = 'Replica quantità su tutte le righe ordine'
                        class      = "btn btn-light" 
                        :disabled  = "variants.length < 2" 
                        @click     = "replicateFirstRowQuantities()"
                      >
                      <i style="color:blueviolet" class="fas fa-clone" aria-hidden="true"></i>  
                    </button>
                </div>
              </div>
          </td>

          <!-- SIZES -->
          <td v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center qty-cell" :class="{ 'qty-zoomed_': activeRow === vIndex }">
                
                <div class="input-wrapper d-flex align-items-center">
                  
                <span  v-if="ControlloMisuraAltriMovimenti(vIndex,size.sizeId)"  class="mr-1" >
                    <i class='fas fa-shopping-cart'></i>

                </span>
                <input :min="0"  :max="1000" 
                
                :disabled = "false"                                 
                required
                type="number"
                :class="{'input-zero' : variant.savedQty[size.sizeId]===0 && update}"
                class="form-control form-control-sm text-center my-number-input input-full"
                v-model.number="variant.quantities[size.sizeId]"
                :ref="'qty-' + vIndex + '-' + sIndex"
               
                @focus="activeRow = vIndex"
                @blur="activeRow = null"

                />

                 
                </div>
              </td>

                  <!-- Totale riga -->
                  <td class="font-weight-bold text-right">
                    {{ totalPerRow(variant) }}
                  </td>

          </tr>
        </tbody>
        <tfoot>
          <tr class="font-weight-bold">

            <td></td>            
            <td class="align-middle">
              <button type="button" class="btn btn-sm btn-info  custom-btn" @click="addVariant">
               <i style="color:yellow" class='fas fa-indent mr-2'></i>
                AGGIUNGI RIGA
              </button>
            </td>
            
                        
            <td></td>

            <td  v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center sticky-col" :style="{ width:  'auto' }">
              {{ size.size }}              
            </td>
            
            <td v-if="false" v-for="size in sizes" class="text-center" :key="size.sizeId">{{ totalPerSize(size) }}</td>
            <!--<td v-for="size in sizes" class="text-center" :key="size.sizeId"></td>-->
            <td class="text-right total">{{ totalGeneral() }}</td> <!-- Totale generale di tutte le righe -->
          </tr>
        </tfoot>        
      </table>

    </div>
    
    
    
    <button :disabled="isSubmitDisabled" type="submit"  class="btn btn-primary float-right mt-2 mr-4">
     <i class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
      PROCEDI
    </button>

</form>

    <div v-if="false">
      <h5 class="mb-4">DATI JSON:</h5>
      <pre> {{ sizes }} {{ counter }} {{ variants }} </pre>       
    </div>
  </div>


  </div>
</template>

<script>

import api                         from '@/api'
//import productCollections          from '@/components/order/ProductCollections.vue'; 
import productCollections          from '@/components/backOffice/ready/ProductCollectionsNew.vue'; 
import sizesList                    from '@/components/backOffice/ready/SizesListNew.vue'; 

import productInfo                 from '@/components/product/ProductInfo.vue';
import productSizeList             from '@/components/order/ProductSizeList.vue';
//import sizesList                   from '@/components/order/SizesList.vue';

import VSelectColors               from '@/components/order/vSelectColors.vue';
//import modalNewColor               from '@/components/order/NewColorForm.vue';
import modalNewColor               from '@/components/backOffice/ready/ColorFormNew.vue';
import EAN                         from "@/utils/index.js";
import priceUpForm                 from './PriceUpForm.vue'  
import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'

import documentHeader              from '@/components/backOffice/ready/DocumentHeader.vue'

import { mapGetters }              from 'vuex'

import { v4 as uuidv4 }            from   'uuid'

export default {
   props : ['product','doc','update'],
   components: {productInfo,
    productSizeList,
    sizesList,
    VSelectColors,
    modalNewColor,
    productCollections,
    priceUpForm,
    modalMessage,
    modalConfirm,documentHeader},
  data() {
    return {
      localProduct   : { ...this.product },
      refresh        : false,       
      sizes          : [],      
     
      variants       : [],      
      activeRow      : null,
      msg            : '',
      colors         : [],
      type           : 'A',
      counter        : 0,
      sizesPricing   : {},
      originalSizes  : [],
      OtherMovements : [],
      labelPrices    : [],
      labelDiscounts : [],
      refreshLabels  : 0,
      uuid           : '',
      
      
    };
  },
   created () 
    {

      this.uuid          = uuidv4()
      this.getColors()
      
      
    },
mounted(){


   if(this.update)
      {
         /* AGGIORNAMENTO MOVIMENTO PRODOTTO  */
        this.getMovementProductVariants()  
      }
      else
      {
        /* NUOVO MOVIMENTO PRODOTTO ESISTENTE */
        this.getProductAllStockMovementDetail()
      }
},
computed: {

  ...mapGetters(['company']) ,  
  
  isSubmitDisabled() {
  
  if(this.update)  
  {
  return (
    
    this.totaliGenerali.ordinato === 0 && this.variants.length > 0
    /*
    this.variants.every(v =>
      Object.values(v.quantities).every(q => q === 0)
    )
    */
  );
  }
  else
  {
    return (
    
    this.totaliGenerali.ordinato === 0 
    /*
    this.variants.every(v =>
      Object.values(v.quantities).every(q => q === 0)
    )
    */
  );
  }

},

totaliGenerali() 
{ 
  let totaleOrdinato = 0; 
  
  this.variants.forEach(item => { 
    const ordinato = item.quantities;     
    const sommaOrdinato = Object.values(ordinato).reduce((a, b) => a + Number(b), 0);     
    totaleOrdinato += sommaOrdinato; 
    
  }); 
    return { ordinato: totaleOrdinato }; 
  }

},

  methods: {
   


    productCollections()
    {
      this.$refs.productCollections.show()
    },
    sizesTable()
    {
      this.$refs.sizesTable.show()
    },
    newColor()
    {
      this.$refs.newColor.show()
    },
    /*
  setLabels(labels)
      { console.log('setLabels',labels)
        this.labels = labels
      },
    */
  async deleteAllProductVariants() {
         
    const msg = 'SI DESIDERA REGISTRARE IL MOVIMENTO SENZA VARIANTI PRODOTTO ?'         
    const confirmed = await this.$refs.confirmModal.show(
          msg,
          { title: 'ATTENZIONE' },1
        )

    if (!confirmed) return
    this.$refs.confirmModal.close()

  try {

    
    /* =========================
       PREPARAZIONE DATI
    ========================== */

    const sp        = 'spDeleteProductFromStockMovement'
    const discounts = []
    const items     = []
    const uuid      = this.uuid
    
    const payload = {
      productId       : this.localProduct.productId,    
      counter         : this.localProduct.counter,
      items,
      companyId       : this.company.Id,
      storeId         : this.doc.storeId,
      stockMovementId : this.doc.stockMovementId,
      discounts,
      uuid,            
      sp             
     

    }


    /* =========================
       CHIAMATA API
    ========================== */
    
    this.$refs.msgModal.show()   
    this.$refs.msgModal.setSpinner(true)
    
    const res = await api.post(payload)

    if (res.status !== 200) 
    {
      throw new Error(res.data ||  res)
    }

    /* =========================
       CONTROLLO RISPOSTA UUID
    ========================== */

   

    await this.$refs.msgModal.show('AGGIORNAMENTO ESEGUITO.',{'title':'MESSAGGIO'},4)
    this.setFinish(items)
    
    

    /* =========================
       SUCCESSO
    ========================== */
      

  }
  catch (err) {

    
    this.$refs.msgModal.show(err.message,{},3)
    

  }
  finally {}

  

},

    /*
    checkOtherMovements(vIndex) {
      
      const { colorId } = this.variants[vIndex]; // destrutturazione
      return this.OtherMovements.some(
        movement => movement.colorId === colorId 
        //&& movement.sizeId === sizeId
      );

      //return false

    },

  */
    
  async  showMessage() {


        const msg = 'QUESTO PRODOTTO CONTIENE VARIANTI GIA\' MOVIMENTATE NEL SISTEMA.\nLA MODIFICA POTREBBE ALTERARE MOVIMENTI GIA\' REGISTRATI.'
        
        await this.$refs.msgModal.show(
          msg,
          { title: 'ATTENZIONE !' },3
        )


      /*
      const { colorId } = this.variants[vIndex]; // destrutturazione
      return this.OtherMovements.some(
        movement => movement.colorId === colorId && movement.sizeId === sizeId
      );
      */ 

    },

  
    ControlloAltriMovimentiBySizeId() {

    return this.sizes.some(s =>
     this.variants.some(item => {
      const { colorId } = item

      return this.OtherMovements.some(movement =>
        movement.colorId === colorId &&
        movement.sizeId === s.sizeId
      )
    })
    )



    },


    ControlloMisuraAltriMovimenti(vIndex,sizeId)
    {
      
      const { colorId } = this.variants[vIndex];
      const status = this.OtherMovements.some(
        movement => movement.colorId === colorId && movement.sizeId === sizeId
      );

     
      return status
      

    },
    ControlloRigaAltriMovimenti(vIndex) {
    
      const { colorId, quantities } = this.variants[vIndex];

      // Prendiamo tutte le sizeId dell'elemento
      const sizeIds = Object.keys(quantities); // ['7','21','27', ...]

      // Creiamo un Set delle sizeId già presenti per questo colorId
      const existingSizes = new Set(
        this.OtherMovements
          .filter(m => m.colorId === colorId)
          .map(m => String(m.sizeId))
      );

        // Controlla se **almeno una** delle sizeId è già presente
        return sizeIds.some(sizeId => existingSizes.has(sizeId));
    },

/*    
ControlloColonnaTutteLeRighe(sizeId) {
  return this.variants.some(variant => {
    const columnObj = variant['quantities'];
    if (!columnObj) return false;

    const existingSizes = new Set(
      this.OtherMovements
        .filter(m => m.colorId === variant.colorId)
        .map(m => String(m.sizeId))
    );

    return existingSizes.has(String(sizeId));
  });
},
*/
                                             
                                             
    setFinish(items)
    {

      
      this.$emit('finish',items)
    },
    setColors(colors)
    {
      this.colors = colors
    },


    async getMovementProductVariants()
    {
                
        this.$refs.msgModal.setSpinner(true)  
        const sp       = 'spStockMovementProductVariants'
        const payload  = {'companyId'       : this.company.Id,
                          'productId'       : this.localProduct.productId,
                          'stockMovementId' : this.doc.stockMovementId,
                          sp
                        }                
        try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
                this.$refs.msgModal.close() 
                this.variants         = res.data.recordsets[0][0]
                this.sizes            = res.data.recordsets[1][0]  
                this.originalSizes    = this.sizes

                this.localProduct     = {...res.data.recordsets[2][0]}                
                this.sizesPricing     = {...res.data.recordsets[3][0],...res.data.recordsets[4][0]}
                
                let variants          = this.fillMissingSizes(this.variants,this.sizes)
                // variants              = this.setNewVariants(variants,this.sizes)

                this.variants         = variants
                this.OtherMovements   = res.data.recordsets[5]
                this.labelPrices      = res.data.recordsets[6]
                this.labelDiscounts   = res.data.recordsets[7]
                              
                if(this.ControlloAltriMovimentiBySizeId())
                {
                  this.$nextTick(() => {
                  this.showMessage()             

                })
                }
                              
               this.refresh = true
          

        }catch(err){

            this.$refs.msgModal.show(err) 
        }
        
        
      },

    async getColors()
    {
        
        const sp       = 'spColorListNew'
        const payload  = {'companyId' : this.company.Id,sp}
        
        try{
        
        const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
          this.colors          = res.data.recordsets[0]
          }catch(err)
          {
            console.log(err)
          }  
                                                        
               
    },

    async getProductAllStockMovementDetail()
    {

        const sp       = 'spProductVariantsAllMovements'
        const payload  = {
                           sp,
                           'productId':this.localProduct.productId} 
        


        try
        {
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
                if(res.data.recordsets[0][0] != null)
                {
                    this.variants         = res.data.recordsets[0][0]
                    this.sizes            = res.data.recordsets[1][0]  
                    this.originalSizes    = this.sizes

                    this.localProduct     = {...res.data.recordsets[2][0]}   
                    //  PRICES - DISCOUNTS             
                    this.sizesPricing     = {...res.data.recordsets[3][0],...res.data.recordsets[4][0]}
                                        
                    let variants          = this.fillMissingSizes(this.variants,this.sizes)
                    // variants              = this.setNewVariants(variants,this.sizes)

                    this.variants         = variants
                    
                    this.refresh = true

                    // console.log('ALTRI MOVIMENTI',res.data.recordsets[5][0])
                }  
                
                          
            }catch(err){

            }
            
       
    },

    getProductEAN13(barcodes,productId, colorId, sizeId) {
      
      const item = barcodes.find(
      b =>
      b.productId == productId &&
      b.colorId == colorId &&
      Number(b.sizeId) == Number(sizeId)

     );
      
       return item ? item.barcode : '';
    },

   
    generateAllBarcodes(productId,counter) {

        let r = counter
      
        const barcodes = this.localProduct.barcodes
    
        this.variants.forEach(variant => {
          if (!variant.barcodes) {
            this.$set(variant, "barcodes", {});
          }

          Object.keys(variant.quantities).forEach(sizeId => {

              const ean13   =  this.getProductEAN13(barcodes,
              productId,
              variant.colorId,
              sizeId   // <-- QUI la chiave è il sizeId

            )

            
            
            const barcode = ean13.length == 13 ? ean13 : EAN.createEAN13(productId,++r)  
            /*
            if(ean13.length == 13)
            {
              barcode = ean13
            }
            else
            {
              console.log('PASSO DA QUI')
              r = r + 1
              barcode = EAN.createEAN13(productId,r)  
            }
            */


            this.$set(variant.barcodes, sizeId, barcode);
          });
      })
      
      return r
    },



    isRowAllZero(variant) {
      const quantities = variant.quantities;
      return Object.values(quantities).every(q => Number(q) === 0);
    },
    
    

    async submit() {

          if(this.update && this.variants.length == 0)
          {
            this.deleteAllProductVariants()
            return
          }



          const getNewZeroSizes = (originalSizes, gridData)  => {
          if (!originalSizes || !gridData) return [];

          // Set delle size originali
          const originalSet = new Set(originalSizes.map(s => Number(s.sizeId)));

          // Prendiamo tutte le size presenti in almeno una riga
          const allSizes = new Set();
          gridData.forEach(color => {
            Object.keys(color.quantities || {}).forEach(size => {
              allSizes.add(Number(size));
            });
          });

          // Filtra solo le nuove size (non originali) completamente a zero
          const newZeroSizes = [...allSizes].filter(size => {
            if (originalSet.has(size)) return false; // non è nuova
            // verifico che tutte le righe abbiano qty = 0
            return gridData.every(color => Number(color.quantities[size] || 0) === 0);
          });

          return newZeroSizes;
        }


      // let colonnaZero     = []

      let righeZero       = []
      this.variants.forEach((variant, index) => {
        if (this.isRowAllZero(variant)) {
          righeZero.push(index);
        }

      });
      
      if (righeZero.length > 0) {

          const righe = righeZero.map(i => i + 1).join(", ")
          this.msg =  "QUANTITA' NON INSERITA ALLA RIGA [ " + righe + ' ] .'
          await this.$refs.msgModal.show(this.msg,{},1)
          //return
      }

      /* SOLO IN UPDATE */
      if(this.update)
      {

      const newSizes = getNewZeroSizes(this.originalSizes,this.variants)
      
      

      if (newSizes.length > 0) {

          
          this.msg =  "QUANTITA' NON INSERITA PER LA NUOVA MISURA."
          await this.$refs.msgModal.show(this.msg)
          return
      }
      }
      else
      {       
              //console.log('MISURE-PRIMA',this.sizes)  

              // uso solo le misure a qty > 0
              const usedSizes = [];
              const seenSizeIds = new Set();  // tiene traccia dei sizeId già aggiunti

                      this.variants.forEach(variant => {
                        Object.entries(variant.quantities).forEach(([sizeId, qty]) => {
                          if (qty > 0 && !seenSizeIds.has(sizeId)) {
                            
                            // MI MANCA LA MISURA CHE HO AGGIUNTO SE TORNO INDIETRO DAL PRICEUP
                            const sizeObj = this.sizes.find(s => Number(s.sizeId) === Number(sizeId));
                            usedSizes.push({
                              sizeId,
                              size     : sizeObj.size,
                              colOrder : sizeObj.colOrder
                              
                            });
                            seenSizeIds.add(sizeId);  // segnalo che questo sizeId è già stato aggiunto
                          }
                        });
                      });

                // ordinare le misure prima di usarle    
                usedSizes.sort((a, b) => a.colOrder - b.colOrder); 
                this.sizes = usedSizes   
  
      }


      this.counter =  this.generateAllBarcodes(this.localProduct.productId,this.localProduct.counter);
      this.localProduct.counter = this.counter      
      this.type = 'B'
      
    
  },



    sanitizeQuantity(variant, sizeId) {

        let value = variant.quantities[sizeId];
        // rimuove tutto ciò che non è numero
        value = String(value).replace(/\D+/g, '');
        this.$set(variant.quantities, sizeId, value ? Number(value) : 0);

    },
    async setColor(colorId,vIndex)
    {   

    
      this.variants[vIndex].colorId = colorId
      this.focusSupplierColor(vIndex)
    },

    setSizes(sizes,sizeId)
    {
     
      
      /*
     if(this.ControlloColonnaTutteLeRighe(sizeId))
     {
      // this.refresh++
      //return
     }
     */

     // console.log(sizeId)
      
      
      this.sizes = sizes
      const  updateQuantitiesFromSizes = (variant, sizes) => {
        const newQuantities = {};
        const newSavedQty   = {};
            sizes.forEach(size => {
          
              newQuantities[size.sizeId] =
              variant.quantities && variant.quantities[size.sizeId] !== undefined
                ? variant.quantities[size.sizeId]
                : 0;

                newSavedQty[size.sizeId] =  variant.savedQty && variant.savedQty[size.sizeId] !== undefined
                ? variant.savedQty[size.sizeId]
                : 0;
              
          });
          
        // sostituzione completa → reattiva in Vue 2
        this.$set(variant, 'quantities', newQuantities);
        this.$set(variant, 'savedQty', newSavedQty);
      }
 
      this.variants.forEach(variant => {
        updateQuantitiesFromSizes(variant, this.sizes);
      });

    },

    setProductSizesList(items)
    {



        
        // console.log('PRODUCT SIZES LIST ',items)

        if(items.length > 0 && this.sizes.length == 0)
        {
          this.sizes = items
          
        }  
        
        this.refresh = true 

        
        
        // this.addVariant()
        
      
                  

    },
    onColorSelect(vIndex) {
    const variant = this.variants[vIndex]

    // focus automatico sulla prima misura
    this.focusFirstQuantity(vIndex)
  },  


     totalPerRow(variant) {
       
         return Object.values(variant.quantities).reduce((sum, q) => sum + (q || 0), 0);
         
      },
      /*
      totalPerSize(size) {
          return this.variants.reduce((sum, v) => sum + (v.quantities[size] || 0), 0);
      },
      */
      totalGeneral() {
        return this.variants.reduce((sum, v) => sum + this.totalPerRow(v), 0);
      },
    
      
    focusSupplierColor(rowIndex) {
    this.$nextTick(() => {
      //if (this.sizes.length === 0) return;

      const refName = 'supplierColor-' + rowIndex ;
      const ref = this.$refs[refName];

      // Vue 2.6: $refs può essere un array se ref è dentro v-for
      const input = Array.isArray(ref) ? ref[0] : ref;

      if (input && input.focus) input.focus();
    });
    },
  

    focusFirstQuantity(rowIndex) {
    this.$nextTick(() => {
      if (this.sizes.length === 0) return;

      const refName = 'qty-' + rowIndex + '-0';
      const ref = this.$refs[refName];

      // Vue 2.6: $refs può essere un array se ref è dentro v-for
      const input = Array.isArray(ref) ? ref[0] : ref;

      if (input && input.focus) input.focus();
    });
    },
   
  createEmptyVariant() {
  return {
    
    colorId          : null,
    supplierColor    : '',
    
    quantities       : this.sizes.reduce((acc, s) => {
      acc[s.sizeId] = 0;
      return acc;
    }, {})

,
      savedQty      : this.sizes.reduce((acc, s) => {
      acc[s.sizeId] = 0;
      return acc;
    }, {})


    }
    },

    addVariant() {
      
      this.variants.push(this.createEmptyVariant());
    },

    async removeVariant(index) {
     
      if(this.ControlloRigaAltriMovimenti(index))
      {
        
        const msg = 'QUESTA RIGA CONTIENE MISURE GIÀ MOVIMENTATE NEL SISTEMA.\n PROCEDENDO POTRESTI ALTERARE MOVIMENTI GIÀ REGISTRATI.\n\nVUOI PROCEDERE COMUNQUE?'
        
        const confirmed=  await this.$refs.confirmModal.show(
          msg,
          { title: 'ATTENZIONE !' },3
        )

          if (!confirmed) return  

      }



     const row = index + 1 
     const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA ELIMINARE LA RIGA  [ ' + row  + ' ]  ?',
          { title: 'CONFERMA' },1
        )

      if (!confirmed) return  

      this.$refs.confirmModal.close()
      this.variants.splice(index, 1);
      
    },

    
    
    validateQuantity(variant, size) {
      if (variant.quantities[size] < 0) variant.quantities[size] = 0;
    },

    fillColumn(size, value) {
      this.variants.forEach(variant => {
        this.$set(variant.quantities, size, value);
      });
    },

    
    async replicateFirstRowQuantities() {
        if (!this.variants.length) return;
        if (!this.variants.length == 1) return;

       const confirmed = await this.$refs.confirmModal.show(
          'SI DESIDERA REPLICARE LA QUANTITA SU TUTTE LE RIGHE ? ',
          { title: 'CONFERMA' },1
        )

        if (!confirmed) return

        this.$refs.confirmModal.close()
        const sourceQuantities = this.variants[0].quantities;

        this.variants.forEach((variant, index) => {
          if (index === 0) return;

          // copia PROFONDA + reattiva
          this.$set(variant, 'quantities', { ...sourceQuantities });
        });
    },

    fillMissingSizes(variants, sizes) {
    return variants.map(color => {

      // Copio l'oggetto quantities
      const newQuantities = { ...color.quantities };
      const newSavedQty = { ...color.savedQty };
      // Per ogni size controllo se esiste, altrimenti metto 0
      sizes.forEach(size => {
        if (!(size.sizeId in newQuantities)) {
          newQuantities[size.sizeId] = 0
          newSavedQty[size.sizeId]   = 0          
        }

        
      });

    return {
      ...color,
      quantities   : newQuantities,
      savedQty     : newSavedQty  
    };
  });
},


setNewVariants(variants, sizes) {
    return variants.map(color => {

      // Copio l'oggetto quantities
      //const newQuantities = { ...color.quantities };
      const newSavedQty   = { ...color.savedQty };
      const newItems      = {}
      // Per ogni size controllo se esiste
      sizes.forEach(size => {
        if (!(size.sizeId in newSavedQty)) {
          
          newItems[size.sizeId]      = true
          
        }

        
      });

    return {
      ...color,
    /*  quantities   : newQuantities,
      savedQty     : newSavedQty,
     */ 
      newItems     : newItems
    };
  });
},
  
    /*
    totalPerSize(size) {
      return this.variants.reduce((sum, v) => sum + (v.quantities[size] || 0), 0);
    },
    */
  },
};
</script>

<style scoped>


.qty-cell {
  transition: all 0.2s ease;
}

.qty-zoomed input {
  font-size: 1.2rem;
  height: 38px;
  font-weight: 600;
}

.qty-zoomed {
  background: #fff;
}


.page-header {
  position: fixed;
  top: 50;
  left: 0;
  width: 100%;
  z-index: 1000; /* sopra Bootstrap navbar/table */
  background-color: #fff;
}

/* header */
thead th.sticky-col {
  z-index: 20;
  background: #28a745;
  color: white;
  border-color: white !important;
  border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
  
  padding-top       : 6px; /* distanza dal bordo superiore */ 
  padding-bottom    : 6px; /* distanza dal bordo inferiore */ 
  padding-left      : 8px; /* opzionale */ 
  padding-right     : 8px; /* opzionale */

}



/* footer */
tfoot td.sticky-col {
  z-index: 20;
  color : white;
  background: #28a745;
  border-color: white !important;
   border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
}

/* celle normali */
tbody td {
  background: #fff;
}



.vs__dropdown-menu {
  z-index: 1050; /* sopra Bootstrap modals */
}

button:hover {
   cursor        : pointer;
  }
.row-zero 
{
  background-color: #f38e8e !important;
}

.my-table,
.my-table th, 
.my-table td
{
  border-color: #28a745 !important;
}

/*
.td-input 
{
  padding: 0 !important; 
}
*/

.input-full {
 
  /*
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
  */
  font-weight       : bold;  

}

.input-full:focus {
  outline: none;
  border: 3px solid #2846a7 !important;
  --box-shadow: 0 0 0 2px rgba(0,123,255,.25) !important;
}


.td-input:focus-within {
  box-shadow: inset 0 0 0 3px #28a745;
}

.badge-pill
{
  font-size: large;
}
.total{
  background-color: gainsboro;
  color:blue
}

.custom-btn {
  background-color: #08561a !important;
  height    : 30px;          /* altezza fissa */
  padding     : 0 20px;       /* spazio laterale */
  display     : flex;
  align-items : center;   /* centra verticalmente il testo */
}

.input-wrapper {
  position: relative;
  display: inline-block;
}


.input-wrapper input[disabled] {
  background-color: transparent;  /* niente sfondo */
  border: 1px solid #ccc;         /* puoi cambiare colore bordo se vuoi */
  cursor: not-allowed;            /* indica che è disabilitato */
  color: #333;                    /* colore testo leggibile */
  padding-right: 30px;            /* spazio per icona */
  border : none;
}


.lock-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s, transform 0.2s;
}

.input-wrapper:hover .lock-icon {
  opacity: 1;
  transform: translateY(-50%) scale(1.2); /* leggero ingrandimento al passaggio */
}

.fa-trash-alt{
  color: #a33d02 !important;
  font-size: 18px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.my-number-input {

    background-color     : #f0f8ff;  /* colore di sfondo */
    color                : #5b0bdb;             /* colore del testo */
    border               : 2px solid #224abe;  /* bordo */
    border-radius        : 5px;         /* bordi arrotondati */
    padding              : 5px 10px;          /* padding interno */

}

.input-zero {

    border-color: red;
    background-color: #ffe6e6; /* leggero sfondo rosato */
}


.fa-shopping-cart
{
  color : rgb(255, 0, 8);
  font-size: smaller;
}

.btn1, .btn2, .btn3 {
  border            : 1px solid #08561a;
  background-color  : #c5e7fb;
  color             : #02105b;
  padding           : 6px 12px;
  border-radius     : 4px;
  transition        : all 0.2s ease;
  cursor            : pointer;
}


.btn1:hover,
.btn2:hover,
.btn3:hover
{
    background-color : rgb(228, 223, 223);
    color            : black ;
}

.table {
  border-collapse: separate;
}


</style>
